import type FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import type FindItemResponseMessage from 'owa-service/lib/contract/FindItemResponseMessage';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';
import { MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD } from './TableLoadingConstants';
import { mergeRowResponseFromTop } from 'mini-mail-list-response-processor';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

export const onLoadInitialRowsSucceeded = action('onLoadInitialRowsSucceeded')(
    function onLoadInitialRowsSucceeded(
        tableView: TableView,
        responseMessage: FindConversationResponseMessage | FindItemResponseMessage
    ) {
        // If SearchFolderId is returned in response, set it on the tableView
        if (responseMessage.SearchFolderId) {
            tableView.serverFolderId = responseMessage.SearchFolderId.Id;
        }

        switch (tableView.tableQuery.listViewType) {
            case 0:
                const { Conversations, TotalConversationsInView } =
                    responseMessage as FindConversationResponseMessage;
                mergeRowResponseFromTop(Conversations, tableView, TotalConversationsInView);
                break;

            case 1:
                const { Items, TotalItemsInView } = (responseMessage as FindItemResponseMessage)
                    .RootFolder;
                mergeRowResponseFromTop(Items, tableView, TotalItemsInView);
                break;
        }
        // Set the loaded index to max allowed on initial table load
        tableView.currentLoadedIndex = Math.min(
            MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD,
            tableView.itemIds.length
        );
    }
);
